import React, { useEffect, useState } from 'react'
import { Button, List, Typography } from 'antd';
import styles from './payment.module.css'

import masterCard from '../../assets/card1.png'
import visaCard from '../../assets/card2.png'
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { AntdSubmit } from '../../components';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PaymentCardsMiddleware from '../../store/Middlewares/PaymentCardsMiddleware';
import PaymentCardsActions from '../../store/Actions/PaymentCardsActions';
import AlertAction from '../../store/Actions/AlertActions';
import SubscriptionMiddlewre from '../../store/Middlewares/SubsciptionMiddleware';


function Payments() {
    const { Text } = Typography;
    const [isActive, setIsActive] = useState();

    useEffect(() => {
        getPaymentCards();
        getLanguage();
        getDefaultCard();
    }, []);
    const { state } = useLocation();
    const data = state;
    console.log('data', data)
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const PaymentCardsList = useSelector(
        state => state.PaymentCardsReducer.PaymentCardsList,
    );
    console.log('PaymentCardsList', PaymentCardsList)
    const user = useSelector((state) => state.AuthReducer.user)
    let updatedUser = {
        ...user,
        is_subscribed: true
    }


    const getDefaultCard = () => {
        const defaultCard = PaymentCardsList.filter(x => x.default_card == 1)
        setIsActive(defaultCard[0]?.id)
    };
    const getPaymentCards = () => {
        dispatch(PaymentCardsMiddleware.getPaymentCards())
    };

    const getLanguage = async () => {
        try {
            const language = localStorage.getItem('@selectedLanguage');
            i18n.changeLanguage(language);
        } catch (e) {
            console.log(e);
        }
    };

    const payNow = () => {
        for (let i = 0; i < PaymentCardsList?.length; i++) {
            if (PaymentCardsList[i]?.default_card == 1) {
                let datax = {
                    payment_method_id: PaymentCardsList[i]?.id,
                    plan_id: data?.id,
                    user: updatedUser
                }
                // console.log('datax',datax)
                dispatch(SubscriptionMiddlewre.getPayNow(datax))
                    .then((data) => {
                        dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
                        navigate(-1)
                        // Alert.alert('Note', data?.message, [
                        //     { text: 'OK', onPress: () => navigation.goBack() },
                        // ]);
                    })
                    .catch((error) => {
                        console.log(error.message)
                    })
            }
        }
    }

    const deletePaymentCards = (id, index) => {
        console.log(id, index);
        dispatch(PaymentCardsActions.deletePaymentCard(index));
        dispatch(PaymentCardsMiddleware.deletePaymentCards(id))
            .then(data => {
                dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
            })
            .catch(error => console.log(error));
    };

    const updatePaymentCards = (id, index) => {
        dispatch(PaymentCardsActions.updatePaymentCard(index));
        dispatch(PaymentCardsMiddleware.updatePaymentCards(id))
            .then(data => {
                dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
            })
            .catch(error => console.log(error));
    };

    const navigate = useNavigate()
    return (
        <div className={styles.mainCont}>
            <Text className={styles.paymentText}>Payments</Text>
            <div className={styles.cardMainCont}>
                <Text className={styles.paymentText}>Credit or Debit Card</Text>
                <List
                    dataSource={PaymentCardsList}
                    className={styles.listCont}
                    renderItem={(item, index) => {
                        console.log('item', item)
                        return (
                            // eslint-disable-next-line no-unused-expressions
                            <div onClick={() => { updatePaymentCards(item?.id, index), setIsActive(item?.id) }} className={styles.cardCont} style={{ border: isActive == item?.id && '3px solid var(--secondary-color)' }}>
                                <div>
                                    <img src={item?.card_brand == 'Visa' ? visaCard : masterCard} alt="" />
                                </div>
                                <div>
                                    <Text style={{ color: item?.isActive && 'var(--secondary-color)' }} className={styles.cardNumber}>{'************' + item?.card_end_number}</Text>
                                </div>
                                <div>
                                    {/* <MdModeEditOutline color={item?.isActive ? '#f6921e' : 'white'} size={30} /> */}
                                    <MdDelete onClick={() => { deletePaymentCards(item?.stripe_source_id, index) }} color={item?.isActive ? '#f6921e' : 'white'} size={30} />
                                </div>
                            </div>
                        );
                    }}
                />
                <div className={styles.buttonCont}>
                    <AntdSubmit text={'Add Card'} buttonStyle={{ margin: '10px 0px', width: '100%' }} onClick={() => {
                        navigate('/subscription/AddCard')
                    }} />
                    {PaymentCardsList?.length == 0 ? null :
                        <AntdSubmit text={'Pay Now'} buttonStyle={{ margin: '10px 0px', width: '100%', backgroundColor: 'var(--dark-grey)' }} onClick={() => payNow()} />}
                </div>
            </div>
        </div>
    )
}

export default Payments